import React from 'react';
import partial from 'lodash/partial';
import {Link} from 'react-router-dom';
import {Icon} from 'semantic-ui-react';
import {FormattedMessage} from 'react-intl';
import {formatDate, EmptyFunc} from 'utils/DBUtils';

const dateFormat = 'MM/DD/YY';

export default {
  Winner: props => ({
    header: <FormattedMessage id='multipleWinners.column.winner' />,
    detailFunc: winner => [winner.firstName, winner.lastName].join(' '),
    subRowDetailFunc: EmptyFunc
  }),

  Email: props => ({
    header: <FormattedMessage id='multipleWinners.column.email' />,
    detailFunc: winner => <a href={`mailto:${winner.email}`}>{winner.email}</a>,
    subRowDetailFunc: EmptyFunc
  }),

  Phone: props => ({
    header: <FormattedMessage id='multipleWinners.column.phone' />,
    detailFunc: winner => winner.phone,
    subRowDetailFunc: EmptyFunc
  }),

  Address: props => ({
    header: <FormattedMessage id='multipleWinners.column.address' />,
    detailFunc: winner => {
      const {address1, address2, city, state, zip} = winner;
      return [address1, address2, city, state, zip].join(' ');
    },
    subRowDetailFunc: EmptyFunc
  }),

  PrizeId: props => ({
    header: <FormattedMessage id='multipleWinners.column.prizeId' />,
    detailFunc: winner => winner.prize && (
      <Link to={`/prize/${winner.prize.id}`}>
        {winner.prize.title}
      </Link>
    )
  }),

  WinDate: props => ({
    header: <FormattedMessage id='multipleWinners.column.winDate' />,
    detailFunc: winner => winner.dateWon && formatDate(winner.dateWon, dateFormat)
  }),

  ForfeitDate: props => ({
    header: <FormattedMessage id='multipleWinners.column.forfeitDate' />,
    detailFunc: winner => winner.forfeitDate && formatDate(winner.forfeitDate, dateFormat)
  }),

  PrizeHistory: props => ({
    header: null,
    detailFunc: winner => {
      if (!winner.prizeHistory.length) {
        return null;
      }

      const isExpanded = props.currentExpandedRow === winner.id;
      const toggleSubRow = partial(props[isExpanded ? 'collapseRow' : 'expandRow'], winner.id);
      return <Icon name='eye' className='action-icon' onClick={toggleSubRow} />;
    },
    subRowDetailFunc: EmptyFunc
  })
};



// WEBPACK FOOTER //
// ./public/pages/MultipleWinners/columns.jsx